/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class AddSubscriptionsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        post: (
        ): string => {
            let clientRequestUrl = '/api/v1/subscriptions';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Add or update subscriptions.
     * @param body (optional) The parameter to add multiple subscriptions. For medium, possible values: email, notification, emailWithNotification. When passing an Id, the subscription is updated directly with the value of the medium.
     * @return OK
     */
    post(body?: AddSubscriptionsRequest | undefined): Promise<AddSubscriptionsResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.post(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<AddSubscriptionsResponse>(_response, false, []);
        });
    }
}

export class CloseSubscriptionsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        closeForUsers: (
        ): string => {
            let clientRequestUrl = '/api/v1/subscriptions';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        close: (
        ): string => {
            let clientRequestUrl = '/api/v1/subscriptions/close';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        closeUnauthorized: (
			simulate?: boolean | undefined,
        ): string => {
            let clientRequestUrl = '/api/v1/subscriptions/close-unauthorized?';
            if (simulate === null) {
                throw new Error('The parameter "simulate" cannot be null.');
            } else if (simulate !== undefined) {
                clientRequestUrl += 'simulate=' + encodeURIComponent('' + simulate) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        closeProduct: (
			productId: number,
			deletedByIcId?: string | undefined,
        ): string => {
            let clientRequestUrl = '/api/v1/subscriptions/close/products/{productId}?';
            if (productId === undefined || productId === null) {
                throw new Error('The parameter "productId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{productId}', encodeURIComponent('' + productId));
            if (deletedByIcId === null) {
                throw new Error('The parameter "deletedByIcId" cannot be null.');
            } else if (deletedByIcId !== undefined) {
                clientRequestUrl += 'deletedByIcId=' + encodeURIComponent('' + deletedByIcId) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        closeKeyword: (
			keywordId: number,
			researchCategoryId: number,
			deletedByIcId?: string | undefined,
        ): string => {
            let clientRequestUrl = '/api/v1/subscriptions/close/keywords/{keywordId}/{researchCategoryId}?';
            if (keywordId === undefined || keywordId === null) {
                throw new Error('The parameter "keywordId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{keywordId}', encodeURIComponent('' + keywordId));
            if (researchCategoryId === undefined || researchCategoryId === null) {
                throw new Error('The parameter "researchCategoryId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{researchCategoryId}', encodeURIComponent('' + researchCategoryId));
            if (deletedByIcId === null) {
                throw new Error('The parameter "deletedByIcId" cannot be null.');
            } else if (deletedByIcId !== undefined) {
                clientRequestUrl += 'deletedByIcId=' + encodeURIComponent('' + deletedByIcId) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        closeResearchCategory: (
			researchCategoryId: number,
			deletedByIcId?: string | undefined,
        ): string => {
            let clientRequestUrl = '/api/v1/subscriptions/close/research-category/{researchCategoryId}?';
            if (researchCategoryId === undefined || researchCategoryId === null) {
                throw new Error('The parameter "researchCategoryId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{researchCategoryId}', encodeURIComponent('' + researchCategoryId));
            if (deletedByIcId === null) {
                throw new Error('The parameter "deletedByIcId" cannot be null.');
            } else if (deletedByIcId !== undefined) {
                clientRequestUrl += 'deletedByIcId=' + encodeURIComponent('' + deletedByIcId) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Close all subscriptions of users.
     * @param body (optional) List of IcId of the users on which to close subscriptions
     * @return No Content
     */
    closeForUsers(body?: CloseForUsersRequest | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.closeForUsers(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, ['beginDate', 'endDate']);
        });
    }

    /**
     * Close subscriptions.
     * @param body (optional) The parameter to close subscriptions. For medium, possible values: email, notification, emailWithNotification.
     * @return OK
     */
    close(body?: CloseSubscriptionsRequest | undefined): Promise<CloseSubscriptionsResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.close(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<CloseSubscriptionsResponse>(_response, false, []);
        });
    }

    /**
     * Close unauthorized subscriptions.
     * @param simulate (optional) 
     * @return No Content
     */
    closeUnauthorized(simulate?: boolean | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.closeUnauthorized(
            simulate,
        );

        const options = {
            method: 'DELETE',
            headers: {
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, ['beginDate', 'endDate']);
        });
    }

    /**
     * Close all subscriptions on provided product
     * @param productId Id of product to close subscriptions
     * @param deletedByIcId (optional) Force deleted by IC id else logged user IC id is used (Mainly useful for app2app tools)
     * @return No Content
     */
    closeProduct(productId: number, deletedByIcId?: string | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.closeProduct(
            productId,
            deletedByIcId,
        );

        const options = {
            method: 'DELETE',
            headers: {
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, ['beginDate', 'endDate']);
        });
    }

    /**
     * Close all subscriptions on provided keyword
     * @param keywordId Id of keyword to close subscriptions
     * @param researchCategoryId Research category of the keyword
     * @param deletedByIcId (optional) Force deleted by IC id else logged user IC id is used (Mainly useful for app2app tools)
     * @return No Content
     */
    closeKeyword(keywordId: number, researchCategoryId: number, deletedByIcId?: string | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.closeKeyword(
            keywordId,
            researchCategoryId,
            deletedByIcId,
        );

        const options = {
            method: 'DELETE',
            headers: {
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, ['beginDate', 'endDate']);
        });
    }

    /**
     * Close all subscriptions on provided research category that are not attached to a product
     * @param researchCategoryId Research category
     * @param deletedByIcId (optional) Force deleted by IC id else logged user IC id is used (Mainly useful for app2app tools)
     * @return No Content
     */
    closeResearchCategory(researchCategoryId: number, deletedByIcId?: string | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.closeResearchCategory(
            researchCategoryId,
            deletedByIcId,
        );

        const options = {
            method: 'DELETE',
            headers: {
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, ['beginDate', 'endDate']);
        });
    }
}

export class SearchSubscriptionsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        get: (
			icIds?: string | undefined,
			status?: SearchStatus | undefined,
			include?: string | undefined,
			categoryIds?: string | undefined,
			productIds?: string | undefined,
			sectorIds?: string | undefined,
			keywordIds?: string | undefined,
			companyIds?: string | undefined,
        ): string => {
            let clientRequestUrl = '/api/v1/subscriptions?';
            if (icIds === null) {
                throw new Error('The parameter "icIds" cannot be null.');
            } else if (icIds !== undefined) {
                clientRequestUrl += 'icIds=' + encodeURIComponent('' + icIds) + '&';
            }
            if (status === null) {
                throw new Error('The parameter "status" cannot be null.');
            } else if (status !== undefined) {
                clientRequestUrl += 'status=' + encodeURIComponent('' + status) + '&';
            }
            if (include === null) {
                throw new Error('The parameter "include" cannot be null.');
            } else if (include !== undefined) {
                clientRequestUrl += 'include=' + encodeURIComponent('' + include) + '&';
            }
            if (categoryIds === null) {
                throw new Error('The parameter "categoryIds" cannot be null.');
            } else if (categoryIds !== undefined) {
                clientRequestUrl += 'categoryIds=' + encodeURIComponent('' + categoryIds) + '&';
            }
            if (productIds === null) {
                throw new Error('The parameter "productIds" cannot be null.');
            } else if (productIds !== undefined) {
                clientRequestUrl += 'productIds=' + encodeURIComponent('' + productIds) + '&';
            }
            if (sectorIds === null) {
                throw new Error('The parameter "sectorIds" cannot be null.');
            } else if (sectorIds !== undefined) {
                clientRequestUrl += 'sectorIds=' + encodeURIComponent('' + sectorIds) + '&';
            }
            if (keywordIds === null) {
                throw new Error('The parameter "keywordIds" cannot be null.');
            } else if (keywordIds !== undefined) {
                clientRequestUrl += 'keywordIds=' + encodeURIComponent('' + keywordIds) + '&';
            }
            if (companyIds === null) {
                throw new Error('The parameter "companyIds" cannot be null.');
            } else if (companyIds !== undefined) {
                clientRequestUrl += 'companyIds=' + encodeURIComponent('' + companyIds) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getUsersWithSubscriptions: (
        ): string => {
            let clientRequestUrl = '/api/v1/subscriptions/do-get-users-with-subscriptions';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getSubscribersByProductCount: (
        ): string => {
            let clientRequestUrl = '/api/v1/subscriptions/count-for-products';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getAvailable: (
			icId: string,
			categoryIds?: number[] | undefined,
			productIds?: number[] | undefined,
			sectorIds?: number[] | undefined,
			keywordIds?: number[] | undefined,
			status?: SearchStatus | undefined,
        ): string => {
            let clientRequestUrl = '/api/v1/subscriptions/available/{icId}?';
            if (icId === undefined || icId === null) {
                throw new Error('The parameter "icId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{icId}', encodeURIComponent('' + icId));
            if (categoryIds === null) {
                throw new Error('The parameter "categoryIds" cannot be null.');
            } else if (categoryIds !== undefined) {
                categoryIds && categoryIds.forEach(item => { clientRequestUrl += 'categoryIds=' + encodeURIComponent('' + item) + '&'; });
            }
            if (productIds === null) {
                throw new Error('The parameter "productIds" cannot be null.');
            } else if (productIds !== undefined) {
                productIds && productIds.forEach(item => { clientRequestUrl += 'productIds=' + encodeURIComponent('' + item) + '&'; });
            }
            if (sectorIds === null) {
                throw new Error('The parameter "sectorIds" cannot be null.');
            } else if (sectorIds !== undefined) {
                sectorIds && sectorIds.forEach(item => { clientRequestUrl += 'sectorIds=' + encodeURIComponent('' + item) + '&'; });
            }
            if (keywordIds === null) {
                throw new Error('The parameter "keywordIds" cannot be null.');
            } else if (keywordIds !== undefined) {
                keywordIds && keywordIds.forEach(item => { clientRequestUrl += 'keywordIds=' + encodeURIComponent('' + item) + '&'; });
            }
            if (status === null) {
                throw new Error('The parameter "status" cannot be null.');
            } else if (status !== undefined) {
                clientRequestUrl += 'status=' + encodeURIComponent('' + status) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getAvailableCategories: (
			icId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/subscriptions/available/{icId}/categories';
            if (icId === undefined || icId === null) {
                throw new Error('The parameter "icId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{icId}', encodeURIComponent('' + icId));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getActive: (
			icId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/subscriptions/active/{icId}';
            if (icId === undefined || icId === null) {
                throw new Error('The parameter "icId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{icId}', encodeURIComponent('' + icId));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getSubscriptionsHistory: (
			icId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/subscriptions/history/{icId}';
            if (icId === undefined || icId === null) {
                throw new Error('The parameter "icId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{icId}', encodeURIComponent('' + icId));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getExport: (
			icId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/subscriptions/history/{icId}/export';
            if (icId === undefined || icId === null) {
                throw new Error('The parameter "icId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{icId}', encodeURIComponent('' + icId));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        searchSubscriptions: (
			term?: string | undefined,
        ): string => {
            let clientRequestUrl = '/api/v1/subscriptions/do-search?';
            if (term === null) {
                throw new Error('The parameter "term" cannot be null.');
            } else if (term !== undefined) {
                clientRequestUrl += 'term=' + encodeURIComponent('' + term) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Retrieves subscriptions.
     * @param icIds (optional) Get a list of subscriptions by the id of the contact.
    When the status is Active , it's limited to 1000.
    When the status is Available or IncludeInactive, it's limited to 1.
    Comma separated list of guid.
     * @param status (optional) A status, by default Active if not set
     * @param include (optional) A list of property to load additional data on the corresponding object.
    Available values: category, keyword, product, sector, company.
    Comma separated list of string.
     * @param categoryIds (optional) Get a list of subscriptions by the id of the category.
    Comma separated list of number.
     * @param productIds (optional) Get a list of subscriptions by the id of the product.
    Comma separated list of number.
     * @param sectorIds (optional) Get a list of subscriptions by the id of the sector.
    Comma separated list of number.
     * @param keywordIds (optional) Get a list of subscriptions by the id of the keyword.
    Comma separated list of number.
     * @param companyIds (optional) Get a list of subscriptions by the id of the company.
    Comma separated list of number.
     * @return OK
     */
    get(icIds?: string | undefined, status?: SearchStatus | undefined, include?: string | undefined, categoryIds?: string | undefined, productIds?: string | undefined, sectorIds?: string | undefined, keywordIds?: string | undefined, companyIds?: string | undefined): Promise<SubscriptionModel[]> {
        const clientRequestUrl = this.baseUrl + this.routes.get(
            icIds,
            status,
            include,
            categoryIds,
            productIds,
            sectorIds,
            keywordIds,
            companyIds,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<SubscriptionModel[]>(_response, false, ['beginDate', 'endDate']);
        });
    }

    /**
     * Get a list of user that have subscription given a list of IcId and a Status
     * @param body (optional) List of IcId and Status
     * @return OK
     */
    getUsersWithSubscriptions(body?: GetUsersWithSubscriptionsRequest | undefined): Promise<GetUsersWithSubscriptionsResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getUsersWithSubscriptions(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<GetUsersWithSubscriptionsResponse>(_response, false, []);
        });
    }

    /**
     * Get subscriber's count for products
     * @return OK
     */
    getSubscribersByProductCount(): Promise<GetSubscribersCountForProductsResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getSubscribersByProductCount(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<GetSubscribersCountForProductsResponse>(_response, false, []);
        });
    }

    /**
     * Get available subscriptions
     * @param categoryIds (optional) 
     * @param productIds (optional) 
     * @param sectorIds (optional) 
     * @param keywordIds (optional) 
     * @param status (optional) 
     * @return OK
     */
    getAvailable(icId: string, categoryIds?: number[] | undefined, productIds?: number[] | undefined, sectorIds?: number[] | undefined, keywordIds?: number[] | undefined, status?: SearchStatus | undefined): Promise<AvailableSubscriptions> {
        const clientRequestUrl = this.baseUrl + this.routes.getAvailable(
            icId,
            categoryIds,
            productIds,
            sectorIds,
            keywordIds,
            status,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<AvailableSubscriptions>(_response, false, ['beginDate', 'endDate']);
        });
    }

    /**
     * Get available categories for subscriptions
     * @return OK
     */
    getAvailableCategories(icId: string): Promise<AvailableCategoriesByNature> {
        const clientRequestUrl = this.baseUrl + this.routes.getAvailableCategories(
            icId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<AvailableCategoriesByNature>(_response, false, []);
        });
    }

    /**
     * Get active subscription
     * @return OK
     */
    getActive(icId: string): Promise<ActiveSubscriptions> {
        const clientRequestUrl = this.baseUrl + this.routes.getActive(
            icId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<ActiveSubscriptions>(_response, false, ['beginDate', 'endDate']);
        });
    }

    /**
     * Get subscriptions history for a user
     * @return OK
     */
    getSubscriptionsHistory(icId: string): Promise<SubscriptionsHistoryResult> {
        const clientRequestUrl = this.baseUrl + this.routes.getSubscriptionsHistory(
            icId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<SubscriptionsHistoryResult>(_response, false, ['beginDate', 'endDate']);
        });
    }

    /**
     * Download subscriptions history export for a user
     * @return OK
     */
    getExport(icId: string): Promise<FileResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getExport(
            icId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<FileResponse>(_response, true, ['beginDate', 'endDate']);
        });
    }

    /**
     * Search subscriptions
     * @param term (optional) the term to search for
     * @return OK
     */
    searchSubscriptions(term?: string | undefined): Promise<SearchSubscriptionResult[]> {
        const clientRequestUrl = this.baseUrl + this.routes.searchSubscriptions(
            term,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<SearchSubscriptionResult[]>(_response, false, []);
        });
    }
}

export class AlertsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        searchAlerts: (
        ): string => {
            let clientRequestUrl = '/api/v1/alerts/do-search';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Search subscription alerts
     * @param body (optional) 
     * @return OK
     */
    searchAlerts(body?: SearchSubscriptionAlertRequest | undefined): Promise<SearchSubscriptionAlertResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.searchAlerts(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<SearchSubscriptionAlertResponse>(_response, false, []);
        });
    }
}

export class AppContextsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        get: (
        ): string => {
            let clientRequestUrl = '/api/v1/app-contexts';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Get application context
     * @return OK
     */
    get(): Promise<AppContext> {
        const clientRequestUrl = this.baseUrl + this.routes.get(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<AppContext>(_response, false, []);
        });
    }
}

export class ConfigurationsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getProductSubscriptionConfiguration: (
			productId: number,
        ): string => {
            let clientRequestUrl = '/api/v1/configurations/products/{productId}';
            if (productId === undefined || productId === null) {
                throw new Error('The parameter "productId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{productId}', encodeURIComponent('' + productId));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getKeywordConfiguration: (
			keywordId: number,
        ): string => {
            let clientRequestUrl = '/api/v1/configurations/keywords/{keywordId}';
            if (keywordId === undefined || keywordId === null) {
                throw new Error('The parameter "keywordId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{keywordId}', encodeURIComponent('' + keywordId));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getCategoryConfiguration: (
			categoryId: number,
        ): string => {
            let clientRequestUrl = '/api/v1/configurations/categories/{categoryId}';
            if (categoryId === undefined || categoryId === null) {
                throw new Error('The parameter "categoryId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{categoryId}', encodeURIComponent('' + categoryId));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getAllCategoryConfiguration: (
			onlyVisibleForSubscriptions?: boolean | undefined,
        ): string => {
            let clientRequestUrl = '/api/v1/configurations/categories?';
            if (onlyVisibleForSubscriptions === null) {
                throw new Error('The parameter "onlyVisibleForSubscriptions" cannot be null.');
            } else if (onlyVisibleForSubscriptions !== undefined) {
                clientRequestUrl += 'onlyVisibleForSubscriptions=' + encodeURIComponent('' + onlyVisibleForSubscriptions) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Get product's subscription configuration
     * @param productId ProductId
     * @return OK
     */
    getProductSubscriptionConfiguration(productId: number): Promise<ProductSubscriptionConfig> {
        const clientRequestUrl = this.baseUrl + this.routes.getProductSubscriptionConfiguration(
            productId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<ProductSubscriptionConfig>(_response, false, []);
        });
    }

    /**
     * Get keyword's configuration
     * @param keywordId KeywordId
     * @return OK
     */
    getKeywordConfiguration(keywordId: number): Promise<KeywordConfiguration> {
        const clientRequestUrl = this.baseUrl + this.routes.getKeywordConfiguration(
            keywordId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<KeywordConfiguration>(_response, false, []);
        });
    }

    /**
     * Get research category's configuration
     * @param categoryId categoryId
     * @return OK
     */
    getCategoryConfiguration(categoryId: number): Promise<CategoryConfiguration> {
        const clientRequestUrl = this.baseUrl + this.routes.getCategoryConfiguration(
            categoryId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<CategoryConfiguration>(_response, false, []);
        });
    }

    /**
     * Get all research category's configuration
     * @param onlyVisibleForSubscriptions (optional) onlyVisibleForSubscriptions
     * @return OK
     */
    getAllCategoryConfiguration(onlyVisibleForSubscriptions?: boolean | undefined): Promise<CategoriesConfigurations> {
        const clientRequestUrl = this.baseUrl + this.routes.getAllCategoryConfiguration(
            onlyVisibleForSubscriptions,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<CategoriesConfigurations>(_response, false, []);
        });
    }
}

export class ExclusionCategoriesJournalistClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        get: (
        ): string => {
            let clientRequestUrl = '/api/v1/exclusion/categories-journalist';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        add: (
        ): string => {
            let clientRequestUrl = '/api/v1/exclusion/categories-journalist';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getById: (
			id: number,
        ): string => {
            let clientRequestUrl = '/api/v1/exclusion/categories-journalist/{id}';
            if (id === undefined || id === null) {
                throw new Error('The parameter "id" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{id}', encodeURIComponent('' + id));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        deleteById: (
			id: number,
        ): string => {
            let clientRequestUrl = '/api/v1/exclusion/categories-journalist/{id}';
            if (id === undefined || id === null) {
                throw new Error('The parameter "id" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{id}', encodeURIComponent('' + id));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Retrieves all categories excluded for journalist
     * @return OK
     * @deprecated
     */
    get(): Promise<ExclusionCategoriesJournalist[]> {
        const clientRequestUrl = this.baseUrl + this.routes.get(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<ExclusionCategoriesJournalist[]>(_response, false, []);
        });
    }

    /**
     * Add a new exclusion category for journalist.
     * @param body (optional) An excluded category for journalist to add
     * @return Created
     * @deprecated
     */
    add(body?: AddExclusionCategoriesJournalist | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.add(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, ['beginDate', 'endDate']);
        });
    }

    /**
     * Retrieves a category excluded for journalist
     * @param id The exclusion id
     * @return OK
     * @deprecated
     */
    getById(id: number): Promise<ExclusionCategoriesJournalist> {
        const clientRequestUrl = this.baseUrl + this.routes.getById(
            id,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<ExclusionCategoriesJournalist>(_response, false, []);
        });
    }

    /**
     * Delete the specified exclusion category for journalist.
     * @param id The excluded category for journalist Id
     * @deprecated
     */
    deleteById(id: number): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.deleteById(
            id,
        );

        const options = {
            method: 'DELETE',
            headers: {
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, ['beginDate', 'endDate']);
        });
    }
}

export class HealthClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        get: (
        ): string => {
            let clientRequestUrl = '/api/v1/health';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getDetailed: (
        ): string => {
            let clientRequestUrl = '/api/v1/health/details';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getLiveness: (
        ): string => {
            let clientRequestUrl = '/api/v1/health/liveness';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getReadiness: (
        ): string => {
            let clientRequestUrl = '/api/v1/health/readiness';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Get Health status
     * @return OK
     */
    get(): Promise<HealthStatusReport> {
        const clientRequestUrl = this.baseUrl + this.routes.get(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<HealthStatusReport>(_response, false, []);
        });
    }

    /**
     * Get Health detailed status
     * @return OK
     */
    getDetailed(): Promise<HealthStatusReportDetailed> {
        const clientRequestUrl = this.baseUrl + this.routes.getDetailed(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<HealthStatusReportDetailed>(_response, false, ['executionDateTimeUtc']);
        });
    }

    /**
     * Get liveness
     * @return OK
     */
    getLiveness(): Promise<HealthStatusReport> {
        const clientRequestUrl = this.baseUrl + this.routes.getLiveness(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<HealthStatusReport>(_response, false, []);
        });
    }

    /**
     * Get readiness
     * @return OK
     */
    getReadiness(): Promise<HealthStatusReport> {
        const clientRequestUrl = this.baseUrl + this.routes.getReadiness(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<HealthStatusReport>(_response, false, []);
        });
    }
}

export class LogsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        error: (
        ): string => {
            let clientRequestUrl = '/api/v1/logs/_error';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        info: (
        ): string => {
            let clientRequestUrl = '/api/v1/logs/_info';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        functional: (
        ): string => {
            let clientRequestUrl = '/api/v1/logs/_functional';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Log error
     * @param body (optional) Details of the error that occurred
     * @return No Content
     */
    error(body?: ClientLogError | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.error(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, ['beginDate', 'endDate']);
        });
    }

    /**
     * Log info
     * @param body (optional) Information log to create
     * @return No Content
     */
    info(body?: ClientLog | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.info(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, ['beginDate', 'endDate']);
        });
    }

    /**
     * Log functional
     * @param body (optional) Functional log to create
     * @return No Content
     */
    functional(body?: ClientLogFunctional | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.functional(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, ['beginDate', 'endDate']);
        });
    }
}

export class SettingsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        get: (
			icIds?: string | undefined,
        ): string => {
            let clientRequestUrl = '/api/v1/settings?';
            if (icIds === null) {
                throw new Error('The parameter "icIds" cannot be null.');
            } else if (icIds !== undefined) {
                clientRequestUrl += 'icIds=' + encodeURIComponent('' + icIds) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        add: (
        ): string => {
            let clientRequestUrl = '/api/v1/settings';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        update: (
			id: number,
        ): string => {
            let clientRequestUrl = '/api/v1/settings/{id}';
            if (id === undefined || id === null) {
                throw new Error('The parameter "id" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{id}', encodeURIComponent('' + id));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getById: (
			id: number,
        ): string => {
            let clientRequestUrl = '/api/v1/settings/{id}';
            if (id === undefined || id === null) {
                throw new Error('The parameter "id" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{id}', encodeURIComponent('' + id));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Retrieves settings by parameters
     * @param icIds (optional) Get a list of settings by the id of the contact.
    Comma separated list of guid.
     * @return OK
     */
    get(icIds?: string | undefined): Promise<Settings[]> {
        const clientRequestUrl = this.baseUrl + this.routes.get(
            icIds,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<Settings[]>(_response, false, []);
        });
    }

    /**
     * Add a new settings.
     * @param body (optional) The settings to be added
     * @return Created
     */
    add(body?: AddUpdateSettings | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.add(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, ['beginDate', 'endDate']);
        });
    }

    /**
     * Update the entire settings by id
     * @param id The id of the settings
     * @param body (optional) The settings to update
     * @return No Content
     */
    update(id: number, body?: AddUpdateSettings | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.update(
            id,
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, ['beginDate', 'endDate']);
        });
    }

    /**
     * Retrieves settings by id
     * @param id The settings id
     */
    getById(id: number): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.getById(
            id,
        );

        const options = {
            method: 'GET',
            headers: {
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, ['beginDate', 'endDate']);
        });
    }
}

export class StatisticsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getStatistics: (
        ): string => {
            let clientRequestUrl = '/api/v1/statistics';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Get subscription statistics
     * @return OK
     */
    getStatistics(): Promise<SubscriptionStatisticsModel> {
        const clientRequestUrl = this.baseUrl + this.routes.getStatistics(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<SubscriptionStatisticsModel>(_response, false, []);
        });
    }
}

export class SubscriptionSectorsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        get: (
        ): string => {
            let clientRequestUrl = '/api/v1/subscription-sectors';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        post: (
        ): string => {
            let clientRequestUrl = '/api/v1/subscription-sectors';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getById: (
			id: number,
        ): string => {
            let clientRequestUrl = '/api/v1/subscription-sectors/{id}';
            if (id === undefined || id === null) {
                throw new Error('The parameter "id" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{id}', encodeURIComponent('' + id));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        deleteById: (
			id: number,
        ): string => {
            let clientRequestUrl = '/api/v1/subscription-sectors/{id}';
            if (id === undefined || id === null) {
                throw new Error('The parameter "id" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{id}', encodeURIComponent('' + id));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Retrieves all subscription sectors.
     * @return OK
     * @deprecated
     */
    get(): Promise<SubscriptionSector[]> {
        const clientRequestUrl = this.baseUrl + this.routes.get(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<SubscriptionSector[]>(_response, false, []);
        });
    }

    /**
     * Add a new subscription sector.
     * @param body (optional) The subscription sector to add
     * @return Created
     * @deprecated
     */
    post(body?: AddSubscriptionSector | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.post(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, ['beginDate', 'endDate']);
        });
    }

    /**
     * Retrieves the specified subscription sector.
     * @param id The subscription sector id
     * @return OK
     * @deprecated
     */
    getById(id: number): Promise<SubscriptionSector> {
        const clientRequestUrl = this.baseUrl + this.routes.getById(
            id,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<SubscriptionSector>(_response, false, []);
        });
    }

    /**
     * Delete the specified subscription sector.
     * @param id The subscription sector id
     * @deprecated
     */
    deleteById(id: number): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.deleteById(
            id,
        );

        const options = {
            method: 'DELETE',
            headers: {
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, ['beginDate', 'endDate']);
        });
    }
}

export class TargetingsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getTargetingUsers: (
        ): string => {
            let clientRequestUrl = '/api/v1/targetings/do-get-targeting';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getSpecificTargetingUsers: (
        ): string => {
            let clientRequestUrl = '/api/v1/targetings/do-get-specific-targeting';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getSpecificTargetingSettingsUsers: (
        ): string => {
            let clientRequestUrl = '/api/v1/targetings/do-get-specific-targeting-settings';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Get Targeting user
     * @param body (optional) The parameter to retrieve targeting user
     * @return OK
     */
    getTargetingUsers(body?: GetTargetingRequest | undefined): Promise<GetTargetingResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getTargetingUsers(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<GetTargetingResponse>(_response, false, []);
        });
    }

    /**
     * Get Specific Targeting user
     * @param body (optional) The parameter to retrieve Specific targeting user
     * @return OK
     */
    getSpecificTargetingUsers(body?: GetSpecificTargetingRequest | undefined): Promise<GetTargetingResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getSpecificTargetingUsers(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<GetTargetingResponse>(_response, false, []);
        });
    }

    /**
     * Get Specific Targeting settings users
     * @param body (optional) The parameter to retrieve Specific targeting settings user
     * @return OK
     */
    getSpecificTargetingSettingsUsers(body?: GetSpecificTargetingSettingsUsersRequest | undefined): Promise<GetSpecificTargetingSettingsResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getSpecificTargetingSettingsUsers(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<GetSpecificTargetingSettingsResponse>(_response, false, []);
        });
    }
}

export class ThirdPartiesClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        approveRequest: (
			icId: string,
			vendorId: number,
        ): string => {
            let clientRequestUrl = '/api/v1/third-parties/access/{icId}/request/{vendorId}/approve';
            if (icId === undefined || icId === null) {
                throw new Error('The parameter "icId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{icId}', encodeURIComponent('' + icId));
            if (vendorId === undefined || vendorId === null) {
                throw new Error('The parameter "vendorId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{vendorId}', encodeURIComponent('' + vendorId));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        rejectRequest: (
			icId: string,
			vendorId: number,
        ): string => {
            let clientRequestUrl = '/api/v1/third-parties/access/{icId}/request/{vendorId}/reject';
            if (icId === undefined || icId === null) {
                throw new Error('The parameter "icId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{icId}', encodeURIComponent('' + icId));
            if (vendorId === undefined || vendorId === null) {
                throw new Error('The parameter "vendorId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{vendorId}', encodeURIComponent('' + vendorId));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Approve request
     * @param icId IcId
     * @param vendorId Vendor id
     * @return OK
     */
    approveRequest(icId: string, vendorId: number): Promise<ThirdPartiesAccess> {
        const clientRequestUrl = this.baseUrl + this.routes.approveRequest(
            icId,
            vendorId,
        );

        const options = {
            method: 'PUT',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<ThirdPartiesAccess>(_response, false, ['openRequestedDate', 'openDate', 'openRejectedDate', 'closeRequestedDate', 'closeDate', 'closeRejectedDate']);
        });
    }

    /**
     * Reject request
     * @param icId IcId
     * @param vendorId Vendor id
     * @return OK
     */
    rejectRequest(icId: string, vendorId: number): Promise<ThirdPartiesAccess> {
        const clientRequestUrl = this.baseUrl + this.routes.rejectRequest(
            icId,
            vendorId,
        );

        const options = {
            method: 'PUT',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<ThirdPartiesAccess>(_response, false, ['openRequestedDate', 'openDate', 'openRejectedDate', 'closeRequestedDate', 'closeDate', 'closeRejectedDate']);
        });
    }
}

export class UsersClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        get: (
			icId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/users/{icId}';
            if (icId === undefined || icId === null) {
                throw new Error('The parameter "icId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{icId}', encodeURIComponent('' + icId));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Get user information
     * @return OK
     */
    get(icId: string): Promise<UserInfo> {
        const clientRequestUrl = this.baseUrl + this.routes.get(
            icId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<UserInfo>(_response, false, []);
        });
    }
}

export interface ActiveSubscriptions {
    natures?: ActiveSubscriptionsNature[] | undefined;
}

export interface ActiveSubscriptionsCategory {
    id: number;
    name?: string | undefined;
    analysts?: Analyst[] | undefined;
    subscriptions?: Subscription[] | undefined;
}

export interface ActiveSubscriptionsGroup {
    id: number;
    name?: string | undefined;
    hasUniqueCategory: boolean;
    categories?: ActiveSubscriptionsCategory[] | undefined;
}

export interface ActiveSubscriptionsNature {
    id: number;
    name?: string | undefined;
    groups?: ActiveSubscriptionsGroup[] | undefined;
}

export interface AddExclusionCategoriesJournalist {
    categoryId: number;
}

export interface AddItem {
    id?: number | undefined;
}

export interface AddSubscriptionRequest {
    id?: number | undefined;
    icId: string;
    createdBy: string;
    type: SubscriptionType;
    category?: AddItem | undefined;
    product?: AddItem | undefined;
    keyword?: AddItem | undefined;
    sector?: AddItem | undefined;
    company?: AddItem | undefined;
    medium: Medium;
}

export interface AddSubscriptionResponse {
    isSuccess: boolean;
    message?: string | undefined;
    subscription?: AddedSubscription | undefined;
}

export interface AddSubscriptionSector {
    categoryId: number;
    productId: number;
    sectorId: number;
}

/** An object representing subscriptions to add */
export interface AddSubscriptionsRequest {
    /** Subscriptions */
    subscriptions: AddSubscriptionRequest[];
}

/** A object representing subcriptions added */
export interface AddSubscriptionsResponse {
    /** Results */
    results?: AddSubscriptionResponse[] | undefined;
}

export interface AddUpdateSettings {
    icId: string;
    language: Language;
}

export interface AddedSubscription {
    id: number;
    icId: string;
    createdBy: string;
    type: SubscriptionType;
    category?: AddItem | undefined;
    product?: AddItem | undefined;
    keyword?: AddItem | undefined;
    sector?: AddItem | undefined;
    company?: AddItem | undefined;
    medium: Medium;
}

export interface Analyst {
    id: number;
    firstname?: string | undefined;
    lastname?: string | undefined;
}

/** App context */
export interface AppContext {
    /** Logged user */
    loggedUser?: LoggedUser | undefined;
    /** Environment */
    environment?: string | undefined;
}

/** AvailableCategoriesByNature */
export interface AvailableCategoriesByNature {
    /** Natures */
    natures?: AvailableNature[] | undefined;
}

export interface AvailableGroup {
    id: number;
    name?: string | undefined;
    rank: number;
    subscriptionsCount: number;
    categoryIds?: number[] | undefined;
}

export interface AvailableMedium {
    products?: string[] | undefined;
    keywords?: string[] | undefined;
}

export interface AvailableNature {
    id: number;
    name?: string | undefined;
    subscriptionsCount: number;
    groups?: AvailableGroup[] | undefined;
}

export interface AvailableSubscription {
    products?: SubscriptionsGroupByCategory[] | undefined;
    keywords?: SubscriptionsGroupByCategory[] | undefined;
    sectors?: SectorsSubscription | undefined;
}

export interface AvailableSubscriptions {
    available?: AvailableSubscription | undefined;
    mediums?: AvailableMedium | undefined;
}

/** Categories configurations */
export interface CategoriesConfigurations {
    /** Configurations */
    configurations?: CategoryConfiguration[] | undefined;
}

export interface CategoryConfiguration {
    categoryId: number;
    visibleForSubscriptions: boolean;
}

export interface CategoryModel {
    id: number;
    name?: string | undefined;
    group?: GroupModel | undefined;
    nature?: NatureModel | undefined;
}

export interface CategorySubscription {
    id: number;
    name?: string | undefined;
    subscription?: Subscription | undefined;
}

export interface CategorySubscriptionAlert {
    researchCategoryId: number;
    icId: string;
}

/** Client log */
export interface ClientLog {
    /** Message */
    message?: string | undefined;
    /** Custom Parameters */
    customParameters?: { [key: string]: any; } | undefined;
}

export interface ClientLogError {
    /** Message */
    message?: string | undefined;
    /** Custom Parameters */
    customParameters?: { [key: string]: any; } | undefined;
    /** Name */
    name?: string | undefined;
    /** Stack Trace */
    stackTrace?: string | undefined;
    /** Page Url */
    pageUrl?: string | undefined;
}

export interface ClientLogFunctional {
    /** Message */
    message?: string | undefined;
    /** Custom Parameters */
    customParameters?: { [key: string]: any; } | undefined;
    /** Feature */
    feature?: string | undefined;
}

export interface CloseForUsersRequest {
    icIds?: string[] | undefined;
    closedByIcId?: string | undefined;
}

export interface CloseSubscriptionRequest {
    id: number;
    deletedByIcId: string;
    medium: Medium;
}

export interface CloseSubscriptionResponse {
    subscription?: CloseSubscriptionRequest | undefined;
    isSuccess: boolean;
    message?: string | undefined;
}

export interface CloseSubscriptionsRequest {
    subscriptions?: CloseSubscriptionRequest[] | undefined;
    icIds?: string[] | undefined;
    onlyOnProductsWithInsightAccessRequired?: boolean | undefined;
}

/** Close subscriptions response */
export interface CloseSubscriptionsResponse {
    /** Results */
    results?: CloseSubscriptionResponse[] | undefined;
}

export interface CompanyModel {
    id: number;
    name?: string | undefined;
    ric?: string | undefined;
    bloombergCode?: string | undefined;
    sector?: string | undefined;
    country?: string | undefined;
    region?: string | undefined;
    analyst?: string | undefined;
}

export interface EmailModel {
    isActive: boolean;
    canSubscribe: boolean;
    reason?: Reason | undefined;
    reasonMessage?: string | undefined;
}

export interface ErrorDto {
    code?: string | undefined;
    message?: string | undefined;
    target?: string | undefined;
    details?: ErrorDto[] | undefined;
}

export interface ExclusionCategoriesJournalist {
    id: number;
    categoryId: number;
}

/** Get Targeting request */
export interface GetSpecificTargetingRequest {
    /** Get a list of targeting subscriptions by the id of the Research Category. */
    researchCategoryIds?: number[] | undefined;
    /** Get a list of targeting subscriptions by the id of the Product. */
    productIds?: number[] | undefined;
    /** Get a list of targeting subscriptions by the id of the sector. */
    sectorIds?: number[] | undefined;
    /** Get a list of targeting subscriptions by Keyword Category. */
    keywordCategoryIds?: number[] | undefined;
}

/** Get Specific Targeting settings response */
export interface GetSpecificTargetingSettingsResponse {
    /** Targeting Settings */
    targetingUsers?: TargetingUserSettings[] | undefined;
}

/** Get Specific Targeting By IcIds Users */
export interface GetSpecificTargetingSettingsUsersRequest {
    /** List of IcIds to target */
    icIds?: string[] | undefined;
}

/** Get Subscribers Count By Products Response */
export interface GetSubscribersCountForProductsResponse {
    /** Subscribers By Product Count */
    subscribersCountForProducts?: SubscribersCountForProductsDao[] | undefined;
}

/** Get Targeting request */
export interface GetTargetingRequest {
    /** Product Id */
    productId: number;
    /** Get a list of targeting subscriptions by the id of the sector. */
    sectorIds?: number[] | undefined;
    /** Get a list of targeting subscriptions by the id of the third. */
    thirdIds?: number[] | undefined;
    /** Get a list of targeting subscriptions by the id of the keyword. */
    keywordIds?: number[] | undefined;
}

/** Get Targeting response */
export interface GetTargetingResponse {
    /** Targeting Subscriptions */
    targetingUsers?: TargetingUserModel[] | undefined;
}

/** Request for GetUsersWithSubscriptions */
export interface GetUsersWithSubscriptionsRequest {
    /** List of users IcId to search */
    icIds?: string[] | undefined;
    /** A status, by default Active if not set */
    status?: SearchStatus | undefined;
}

/** Responnse for GetUsersWithSubscriptions */
export interface GetUsersWithSubscriptionsResponse {
    /** List of user IcId who have subscriptions */
    icIds?: string[] | undefined;
}

export interface GroupModel {
    id: number;
    name?: string | undefined;
}

export interface HealthCheckReportEntryDetailed {
    name?: string | undefined;
    status: HealthStatus;
    type?: string | undefined;
    description?: string | undefined;
    tags?: string[] | undefined;
    data?: { [key: string]: any; } | undefined;
    problems?: Problem[] | undefined;
}

export enum HealthStatus {
    Unhealthy = "unhealthy",
    Degraded = "degraded",
    Healthy = "healthy",
}

export interface HealthStatusReport {
    status: HealthStatus;
}

export interface HealthStatusReportDetailed {
    status: HealthStatus;
    executionDateTimeUtc: Date;
    apiCode?: string | undefined;
    checks?: HealthCheckReportEntryDetailed[] | undefined;
}

export interface KeywordConfiguration {
    keywordId: number;
    visibilities?: KeywordVisibilityConfiguration[] | undefined;
}

export interface KeywordModel {
    id: number;
    name?: string | undefined;
}

export interface KeywordVisibilityConfiguration {
    researchCategoryId: number;
    visibleForSubscriptions: boolean;
    massSubscriptionIcIds?: string[] | undefined;
    massUnsubscriptionIcIds?: string[] | undefined;
}

export enum Language {
    English = "english",
    French = "french",
    Japanese = "japanese",
}

export interface LoggedUser {
    id: string;
    email: string | undefined;
    permissions: string[] | undefined;
    isInternal: boolean;
    contractLink?: string | undefined;
    mifid2StatusImpacted: boolean;
    fullName: string | undefined;
}

export enum Medium {
    Email = "email",
    Notification = "notification",
    EmailWithNotification = "emailWithNotification",
}

export interface MediumModel {
    email?: EmailModel | undefined;
    notification?: NotificationModel | undefined;
}

export interface NatureModel {
    id: number;
    name?: string | undefined;
}

export interface NotificationModel {
    isActive: boolean;
    canSubscribe: boolean;
    reason?: Reason | undefined;
    reasonMessage?: string | undefined;
}

export interface Problem {
    detail?: string | undefined;
}

export interface ProductModel {
    id: number;
    name?: string | undefined;
}

export interface ProductSubscriptionAlert {
    productId: number;
    icId: string;
}

export interface ProductSubscriptionConfig {
    productId: number;
    visibleForSubscriptions: boolean;
}

export enum Reason {
    Journalist = "journalist",
    Mifid2 = "mifid2",
    InsightAccess = "insightAccess",
    ProductVisibilityGroup = "productVisibilityGroup",
}

export enum SearchStatus {
    Active = "active",
    Available = "available",
    IncludeInactive = "includeInactive",
    IncludeLatestInactive = "includeLatestInactive",
}

/** Request to search subscriptions alerts */
export interface SearchSubscriptionAlertRequest {
    /** User Ic Ids */
    icIds?: string[] | undefined;
    /** Research categories ids */
    researchCategoryIds?: number[] | undefined;
    /** Product ids */
    productIds?: number[] | undefined;
}

export interface SearchSubscriptionAlertResponse {
    categorySubscriptionAlerts?: CategorySubscriptionAlert[] | undefined;
    productSubscriptionAlerts?: ProductSubscriptionAlert[] | undefined;
}

export interface SearchSubscriptionResult {
    type: SubscriptionType;
    subscriptionId: number;
    categoryId: number;
    name?: string | undefined;
    group?: SearchSubscriptionResultGroup | undefined;
    nature?: SearchSubscriptionResultNature | undefined;
    matchedBy?: SubscriptionMatch[] | undefined;
}

export interface SearchSubscriptionResultGroup {
    id: number;
    name?: string | undefined;
}

export interface SearchSubscriptionResultNature {
    id: number;
    name?: string | undefined;
}

export interface SectorByProduct {
    productName?: string | undefined;
    productId: number;
    availableMediums?: string[] | undefined;
    subscription?: Subscription | undefined;
}

export interface SectorModel {
    id: number;
    name?: string | undefined;
}

export interface SectorSubscription {
    sectorId: number;
    sectorName?: string | undefined;
    sectorByProducts?: SectorByProduct[] | undefined;
}

export interface SectorsSubscription {
    sectorProducts?: SectorByProduct[] | undefined;
    sectorSubscriptions?: SectorSubscription[] | undefined;
}

export interface Settings {
    id: number;
    icId: string;
    language: Language;
    email?: string | undefined;
}

export interface StatisticsByKeywordModel {
    keywordId: number;
    researchCategoryId: number;
    subscriptionCount: number;
}

export interface StatisticsByProductModel {
    productId: number;
    subscriptionCount: number;
}

export enum Status {
    Active = "active",
    Available = "available",
    Inactive = "inactive",
}

export interface SubscribersCountForProductsDao {
    productId: number;
    subscribersCount: number;
}

export interface Subscription {
    id?: number | undefined;
    icId?: string | undefined;
    type: SubscriptionType;
    name?: string | undefined;
    categoryId: number;
    productId?: number | undefined;
    keywordId?: number | undefined;
    sectorId?: number | undefined;
    medium?: MediumModel | undefined;
    createdByFullName?: string | undefined;
    deletedByFullName?: string | undefined;
    beginDate?: Date | undefined;
    endDate?: Date | undefined;
}

export interface SubscriptionHistory {
    id: number;
    beginDate?: Date | undefined;
    endDate?: Date | undefined;
    createdBy?: string | undefined;
    createdOnBehalfOf?: string | undefined;
    deletedOnBehalfOf?: string | undefined;
    deletedBy?: string | undefined;
    categoryId: number;
    categoryName?: string | undefined;
    sectorId?: number | undefined;
    sectorName?: string | undefined;
    productId?: number | undefined;
    productName?: string | undefined;
    keywordId?: number | undefined;
    keywordName?: string | undefined;
    companyId?: number | undefined;
    companyName?: string | undefined;
}

export interface SubscriptionMatch {
    type: SubscriptionMatchType;
    name?: string | undefined;
}

export enum SubscriptionMatchType {
    Name = "name",
    Product = "product",
}

export interface SubscriptionModel {
    id?: number | undefined;
    icId?: string | undefined;
    status: Status;
    beginDate?: Date | undefined;
    endDate?: Date | undefined;
    createdBy?: string | undefined;
    createdOnBehalfOf?: string | undefined;
    deletedOnBehalfOf?: string | undefined;
    deletedBy?: string | undefined;
    type: SubscriptionType;
    category?: CategoryModel | undefined;
    product?: ProductModel | undefined;
    keyword?: KeywordModel | undefined;
    sector?: SectorModel | undefined;
    company?: CompanyModel | undefined;
    medium?: MediumModel | undefined;
}

export interface SubscriptionSector {
    subscriptionSectorId: number;
    categoryId: number;
    productId: number;
    sectorId: number;
}

export interface SubscriptionStatisticsModel {
    byKeyword?: StatisticsByKeywordModel[] | undefined;
    byProduct?: StatisticsByProductModel[] | undefined;
}

export enum SubscriptionType {
    Unknown = "unknown",
    Category = "category",
    Product = "product",
    Keyword = "keyword",
    Sector = "sector",
}

export interface SubscriptionsGroupByCategory {
    category?: CategorySubscription | undefined;
    subscriptions?: Subscription[] | undefined;
}

export interface SubscriptionsHistoryResult {
    histories?: SubscriptionHistory[] | undefined;
}

export interface TargetingUserModel {
    icId: string;
    languageIsoCode2?: string | undefined;
    isEmailSubscribe: boolean;
    isNotificationSubscribe: boolean;
}

export interface TargetingUserSettings {
    icId: string;
    languageIsoCode2?: string | undefined;
}

export interface ThirdPartiesAccess {
    actions?: ThirdPartiesAccessAction[] | undefined;
    id: number;
    icId?: string | undefined;
    status: ThirdPartyStatus;
    thirdParty?: ThirdParty | undefined;
    openRequestedByIcId?: string | undefined;
    openRequestedDate?: Date | undefined;
    openByIcId?: string | undefined;
    openDate?: Date | undefined;
    openRejectedByIcId?: string | undefined;
    openRejectedDate?: Date | undefined;
    closeRequestedByIcId?: string | undefined;
    closeRequestedDate?: Date | undefined;
    closeByIcId?: string | undefined;
    closeDate?: Date | undefined;
    closeRejectedByIcId?: string | undefined;
    closeRejectedDate?: Date | undefined;
}

export enum ThirdPartiesAccessAction {
    RequestOpen = "requestOpen",
    Open = "open",
    RejectOpen = "rejectOpen",
    RequestClose = "requestClose",
    Close = "close",
    RejectClose = "rejectClose",
    UpdateUserId = "updateUserId",
}

export interface ThirdParty {
    id: number;
    name?: string | undefined;
    userId?: string | undefined;
}

export enum ThirdPartyStatus {
    None = "none",
    RequestOpenPending = "requestOpenPending",
    Opened = "opened",
    RequestClosePending = "requestClosePending",
    Closed = "closed",
}

export interface UserInfo {
    id: string;
    email: string | undefined;
    permissions: string[] | undefined;
    isInternal: boolean;
    contractLink?: string | undefined;
    mifid2StatusImpacted: boolean;
    fullName: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

export class Utilities
{
    public static async processResponse<T>(
        response: Response,
        isFile: boolean,
        dateFields: string[],
    ): Promise<T> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if (status >= 200 && status < 300) {
            if (isFile) {
                const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
                const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
                return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers } as unknown as T; });
            }
            if (response && response.text) {
                return response.text().then((_responseText) => {
                    try {
                        const result: any = _responseText === '' ? null : JSON.parse(_responseText, (key, value) => {
                            if (value
                                && dateFields?.includes(key)
                                && (typeof value === 'string' || (Array.isArray(value) && value.every(i => typeof i === 'string'))) 
                                ) {
                               if (Array.isArray(value)) {
                                    return value.map(v => Utilities.ConvertToDate(v));
                                }
                                else {
                                    return Utilities.ConvertToDate(value);
                                }
                            }
                            return value;
                        }) as T;
                        return result;
                    } catch (error) {
                        return Promise.reject(new SwaggerException(error instanceof Error ? error.message : 'JSON.parse error', status, _responseText, _headers, null));
                    }
                });
            }
            else {
                return Promise.resolve<T>(<any>null);
            }
        }

        const errorMessage = status < 500 ? 'A server error occurred.' : 'An unexpected server error occurred.';

        if (response instanceof Error) {
        	return Promise.reject(new SwaggerException(response.message, status, response.message, _headers, null));
        }

        if (response && response.text) {
        	const responseText = await response.text();
        	return Promise.reject(new SwaggerException(errorMessage, status, responseText, _headers, null));
        }

        return Promise.resolve<T>(<any>null);
    }

    public static ConvertToDate (value: any) {
        const date = new Date(value);
        return isNaN(date.getTime()) ? value : date;
    }
}